import { MDCSelect } from '@material/select';

const filterSidebarEl = document.querySelector('#FilterSidebar');

// Open/close stock filter tab
//
const stocksToggle = document.querySelector(
  '.category-page__sidebar__container__stocks__title'
);
const stocksSelection = document.querySelector(
  '.category-page__sidebar__container__stocks__selection'
);

if (stocksToggle) {
  stocksToggle.addEventListener('click', () => {
    if (stocksSelection.style.maxHeight) {
      stocksSelection.style.maxHeight = null;
      document.querySelector('.category-page__sidebar__container__stocks__title__more').style.transform = '';
      stocksToggle.style.borderBottom = ''
      stocksSelection.style.overflow = ''
    } else {
      stocksSelection.style.maxHeight = '290px'
      document.querySelector('.category-page__sidebar__container__stocks__title__more').style.transform = 'rotate(180deg)';
      stocksToggle.style.borderBottom = 'none'
      stocksSelection.style.overflow = 'auto'
    }
  })
}

// Open/close promosales filter tab

function promosalesToggleState() {
  const promosalesToggle = document.querySelector(
    '.category-page__sidebar__container__promosales__title'
  );
  const promosalesSelection = document.querySelector(
    '.category-page__sidebar__container__promosales__selection'
  );

  if (promosalesToggle) {
    promosalesToggle.addEventListener('click', () => {
      if (promosalesSelection.style.maxHeight) {
        promosalesSelection.style.maxHeight = null;
        document.querySelector('.category-page__sidebar__container__promosales__title__more').style.transform = '';
        promosalesToggle.style.borderBottom = ''
        promosalesSelection.style.overflow = ''
      } else {
        promosalesSelection.style.maxHeight = '290px'
        document.querySelector('.category-page__sidebar__container__promosales__title__more').style.transform = 'rotate(180deg)';
        promosalesToggle.style.borderBottom = 'none'
        promosalesSelection.style.overflow = 'auto'
      }
    })
  }

  if (promosalesSelection) {
    const inputPromosales = document.querySelectorAll(
      '.category-page__sidebar__container__promosale__selection__input'
    );
    inputPromosales.forEach((element) => {
      element.addEventListener('input', () => {
        reloadFilters(element)
      })
    })
  }
}
promosalesToggleState()

// Open/close gcat filter tab

const gcatsToggle = document.querySelector(
  '.category-page__sidebar__container__gcats__title'
);
const gcatsSelection = document.querySelector(
  '.category-page__sidebar__container__gcats__selection'
);

if (gcatsToggle) {
  gcatsToggle.addEventListener('click', () => {
    if (gcatsSelection.style.maxHeight) {
      gcatsSelection.style.maxHeight = null;
      document.querySelector('.category-page__sidebar__container__gcats__title__more').style.transform = '';
      gcatsToggle.style.borderBottom = ''
      gcatsSelection.style.overflow = ''
    } else {
      gcatsSelection.style.maxHeight = '290px'
      document.querySelector('.category-page__sidebar__container__gcats__title__more').style.transform = 'rotate(180deg)';
      gcatsToggle.style.borderBottom = 'none'
      gcatsSelection.style.overflow = 'auto'
    }
  })
}

// Open/close producers filter tab

function producersToggleState(state) {
  const inputProducers = document.querySelectorAll(
    '.category-page__sidebar__container__producer__selection__input'
  );
  const labelProducer = document.querySelectorAll(
    '.category-page__sidebar__container__producer__selection__label'
  );
  const producersSelection = document.querySelector(
    '.category-page__sidebar__container__producers__selection'
  );
  const producersToggle = document.querySelector(
    '.category-page__sidebar__container__producers__title'
  );

  if (producersToggle) {
    producersToggle.addEventListener('click', () => {
      producersMenuAction()
    })
  }

  function producersMenuAction() {
    const producersSelectionFirstElement = document.querySelector(
      '.category-page__sidebar__container__producers__selection > .mdc-form-field'
    );
    const producersSelectionMore = document.querySelector('.category-page__sidebar__container__producers__title__more')
    if (!producersSelectionFirstElement) {
      producersSelectionMore.innerHTML = '<img height="25" src="/images/spinning-arrows.gif">'
      filterSidebarLoad(filterSidebarEl.dataset.params, 'producers')
    } else {
      if (producersSelection.style.maxHeight) {
        producersSelection.style.maxHeight = null;
        document.querySelector('.category-page__sidebar__container__producers__title__more').style.transform = '';
        producersToggle.style.borderBottom = ''
        producersSelection.style.overflow = ''
      } else {
        producersSelection.style.maxHeight = '290px'
        document.querySelector('.category-page__sidebar__container__producers__title__more').style.transform = 'rotate(180deg)';
        producersToggle.style.borderBottom = 'none'
        producersSelection.style.overflow = 'auto'
      }
    }
  }

  if (state) {
   producersMenuAction()
  }

  if (producersSelection) {
    inputProducers.forEach((element) => {
      element.addEventListener('input', () => {
        // document.querySelectorAll('input[type=checkbox]').forEach(el => el.checked = false);
        if (element.checked) {
          labelProducer.forEach((e) => {
            if (element.id == e.htmlFor) {
              e.classList.add('labelOpacity');
            }
          });
        } else {
          labelProducer.forEach((e) => {
            if (element.id == e.htmlFor) {
              if (e.classList.contains('labelOpacity')) {
                e.classList.remove('labelOpacity');
              }
            }
          });
        }
        reloadFilters(element)
      });
    });
  }
}
producersToggleState(false)
//// Price range slider
//
//(function () {
//  var parent = document.querySelector('.price-slider');
//  if (!parent) return;
//
//  var rangeS = parent.querySelectorAll('input[type=range]'),
//    numberS = parent.querySelectorAll('input[type=number]');
//
//  rangeS.forEach(function (el) {
//    el.oninput = function () {
//      var slide1 = parseFloat(rangeS[0].value),
//        slide2 = parseFloat(rangeS[1].value);
//
//      if (slide1 > slide2) {
//        [slide1, slide2] = [slide2, slide1];
//      }
//
//      numberS[0].value = slide1;
//      numberS[1].value = slide2;
//    };
//  });
//
//  numberS.forEach(function (el) {
//    el.oninput = function () {
//      var number1 = parseFloat(numberS[0].value),
//        number2 = parseFloat(numberS[1].value);
//
//      if (number1 > number2) {
//        var tmp = number1;
//        numberS[0].value = number2;
//        numberS[1].value = tmp;
//      }
//
//      rangeS[0].value = number1;
//      rangeS[1].value = number2;
//    };
//  });
//})();
//
//// Open/close price filter tab
//
//const priceToggle = document.querySelector(
//  '.category-page__sidebar__container__price__title'
//);
//
//const priceRange = document.querySelector(
//  '.category-page__sidebar__container__price__range'
//);
//
//if (priceToggle) {
//  priceToggle.addEventListener('click', () => {
//    if (priceRange.style.maxHeight) {
//      priceRange.style.maxHeight = null;
//      document.querySelector('.category-page__sidebar__container__price__title__more').style.transform = '';
//      priceToggle.style.borderBottom = ''
//      priceRange.style.paddingTop = ''
//    } else {
//      priceRange.style.maxHeight = '100px'
//      document.querySelector('.category-page__sidebar__container__price__title__more').style.transform = 'rotate(180deg)';
//      priceToggle.style.borderBottom = 'none'
//      priceRange.style.paddingTop = '20px'
//    }
//  })
//}

// Open/close colors filter tab

function colorsToggleState(state) {
  const colorsToggle = document.querySelector(
    '.category-page__sidebar__container__colors__title'
  );
  const colorsSelection = document.querySelector(
    '.category-page__sidebar__container__colors__selection'
  );

  function colorsMenuAction() {
    const colorsSelectionFirstElement = document.querySelector(
      '.category-page__sidebar__container__colors__selection > .mdc-form-field'
    );
    const colorsSelectionMore = document.querySelector('.category-page__sidebar__container__colors__title__more')
    if (!colorsSelectionFirstElement) {
      colorsSelectionMore.innerHTML = '<img height="25" src="/images/spinning-arrows.gif">'
      filterSidebarLoad(filterSidebarEl.dataset.params, 'colors')
    } else {
      if (colorsSelection.style.maxHeight) {
        colorsSelection.style.maxHeight = null;
        document.querySelector('.category-page__sidebar__container__colors__title__more').style.transform = '';
        colorsToggle.style.borderBottom = ''
        colorsSelection.style.overflow = ''
      } else {
        colorsSelection.style.maxHeight = '290px'
        document.querySelector('.category-page__sidebar__container__colors__title__more').style.transform = 'rotate(180deg)';
        colorsToggle.style.borderBottom = 'none'
        colorsSelection.style.overflow = 'auto'
      }
    }
  }

  if (state) {
   colorsMenuAction()
  }

  if (colorsToggle) {
    colorsToggle.addEventListener('click', () => {
      colorsMenuAction()
    })
  }

  if (colorsSelection) {
    const inputColors = document.querySelectorAll(
      '.category-page__sidebar__container__color__selection__input'
    );
    inputColors.forEach((element) => {
      element.addEventListener('input', () => {
        reloadFilters(element)
      })
    })
  }
}
colorsToggleState(false)

// Open/close sizes filter tab

function sizesToggleState(state) {
  const sizesToggle = document.querySelector(
    '.category-page__sidebar__container__sizes__title'
  );
  const sizesSelection = document.querySelector(
    '.category-page__sidebar__container__sizes__selection'
  );

  function sizesMenuAction() {
    const sizesSelectionFirstElement = document.querySelector(
      '.category-page__sidebar__container__sizes__selection > .mdc-form-field'
    );
    const sizesSelectionMore = document.querySelector('.category-page__sidebar__container__sizes__title__more')
    if (!sizesSelectionFirstElement) {
      sizesSelectionMore.innerHTML = '<img height="25" src="/images/spinning-arrows.gif">'
      filterSidebarLoad(filterSidebarEl.dataset.params, 'sizes')
    } else {
      if (sizesSelection.style.maxHeight) {
        sizesSelection.style.maxHeight = null;
        document.querySelector('.category-page__sidebar__container__sizes__title__more').style.transform = '';
        sizesToggle.style.borderBottom = ''
        sizesSelection.style.overflow = ''
      } else {
        sizesSelection.style.maxHeight = '290px'
        document.querySelector('.category-page__sidebar__container__sizes__title__more').style.transform = 'rotate(180deg)';
        sizesToggle.style.borderBottom = 'none'
        sizesSelection.style.overflow = 'auto'
      }
    }
  }

  if (state) {
   sizesMenuAction()
  }

  if (sizesToggle) {
    sizesToggle.addEventListener('click', () => {
      sizesMenuAction()
    })
  }

  if (sizesSelection) {
    const inputSizes = document.querySelectorAll(
      '.category-page__sidebar__container__size__selection__input'
    );
    inputSizes.forEach((element) => {
      element.addEventListener('input', () => {
        reloadFilters(element)
      })
    })
  }
}
sizesToggleState(false)


const filterButton = document.querySelector(
  '.category-page__content__items__button .filter-button'
);
const sidebar = document.querySelector('.category-page__sidebar');

if (filterButton) {
  filterButton.addEventListener('click', () => {
    document.querySelector('.category-page__sidebar__overlay').style.visibility = 'visible'
    document.querySelector('.category-page__sidebar__overlay').style.opacity = '0.8'
    sidebar.style.visibility = 'visible';
    sidebar.style.opacity = '1';
    document.body.style.overflow = 'hidden';
  })

  const closeSidebar = function () {
    document.querySelector('.category-page__sidebar__overlay').style.visibility = ''
    document.querySelector('.category-page__sidebar__overlay').style.opacity = ''
    sidebar.style.visibility = '';
    sidebar.style.opacity = '';
    document.body.style.overflow = '';
  };

  document.querySelector('.category-page__sidebar__container__close__button').addEventListener('click', closeSidebar);
}

const saleFilterButton = document.querySelector(
  '.sale-filter-button'
);
const saleFilters = document.querySelector('.category-page__content__items__selects__container');

if (saleFilterButton && saleFilters) {
  saleFilterButton.addEventListener('click', () => {
    saleFilters.style.visibility = 'visible'
    saleFilters.style.opacity = '1';
    // categoryMenuList.style.display = 'block';
    document.body.style.overflow = 'hidden';
  })

  const closeMenu = function () {
    saleFilters.style.visibility = ''
    saleFilters.style.opacity = '';
    // categoryMenuList.style.display = 'none';
    document.body.style.overflow = '';
  };

  document.querySelector('.category-sale__close__button').addEventListener('click', closeMenu);
}


// const saleFilterButton = document.querySelector(
//   '.category-page__content__items__button .sale-filter-button'
// );
// const sale_sidebar = document.querySelector('.category-page__content__items');
//
// if (saleFilterButton) {
//     saleFilterButton.addEventListener('click', () => {
//       document.querySelector('.category-page__sidebar__overlay').style.visibility = 'visible'
//       document.querySelector('.category-page__sidebar__overlay').style.opacity = '0.8'
//       sale_sidebar.style.visibility = 'visible';
//       sale_sidebar.style.opacity = '1';
//       document.body.style.overflow = 'hidden';
//     })
//
//     const closeSidebar = function () {
//       document.querySelector('.category-page__sidebar__overlay').style.visibility = ''
//       document.querySelector('.category-page__sidebar__overlay').style.opacity = ''
//       sale_sidebar.style.visibility = '';
//       sale_sidebar.style.opacity = '';
//       document.body.style.overflow = '';
//     };
//
//   document.querySelector('.category-page__sidebar__overlay').addEventListener('click', closeSidebar);
//   document.querySelector('.category-page__sidebar__container__close__button').addEventListener('click', closeSidebar);
// }


if (stocksSelection) {
  const inputStocks = document.querySelectorAll(
    '.category-page__sidebar__container__stock__selection__input'
  );
  inputStocks.forEach((element) => {
    element.addEventListener('input', () => {
      reloadFilters(element)
    })
  })
}

if (gcatsSelection) {
  const inputGcats = document.querySelectorAll(
    '.category-page__sidebar__container__gcat__selection__input'
  );
  inputGcats.forEach((element) => {
    element.addEventListener('input', () => {
      reloadFilters(element)
    })
  })
}

// if (sizesSelection) {
//   const inputSizes = document.querySelectorAll(
//     '.category-page__sidebar__container__size__selection__input'
//   );
//   inputSizes.forEach((element) => {
//     element.addEventListener('input', () => {
//       reloadFilters(element)
//     })
//   })
// }




const sortSelect = document.querySelector('#SortSelect');
if (sortSelect) {
  const sortSelection = new MDCSelect(sortSelect);
  sortSelection.listen('MDCSelect:change', () => {
    reloadFilters(sortSelection, sortSelection.root.dataset.param)
  })
}

const saleSortSelect = document.querySelector('#SaleSortSelect');
const producerSelect = document.querySelector('#ProducerSelect');
const sizeSelect = document.querySelector('#SizeSelect');
const colorSelect = document.querySelector('#ColorSelect');
if (saleSortSelect && producerSelect && sizeSelect && colorSelect) {
  const producerSaleSelection = new MDCSelect(producerSelect);
  //producerSaleSelection.selectedIndex = 1;
  const sizeSaleSelection = new MDCSelect(sizeSelect);
  const colorSaleSelection = new MDCSelect(colorSelect);
  const sortSaleSelection = new MDCSelect(saleSortSelect);
  producerSaleSelection.listen('MDCSelect:change', () => {
    // console.log('producersort')
    reloadSaleFilters()
  })
  sizeSaleSelection.listen('MDCSelect:change', () => {
    reloadSaleFilters()
  })
  colorSaleSelection.listen('MDCSelect:change', () => {
    reloadSaleFilters()
  })
  sortSaleSelection.listen('MDCSelect:change', () => {
    // console.log('sort')
    reloadSaleFilters()
  })

  function reloadSaleFilters() {
    const params = [];

    if (producerSaleSelection.value !== "") {
      params.push('mt=' + producerSaleSelection.value)
    }

    if (sizeSaleSelection.value !== "") {
      params.push('s=' + sizeSaleSelection.value)
    }

    if (colorSaleSelection.value !== "") {
      params.push('c=' + colorSaleSelection.value)
    }

    if (sortSaleSelection.value !== "") {
      params.push('v=' + sortSaleSelection.value)
    }

    // console.log(params)

    if (params.length > 0) {
      location.href = location.pathname + '?' + params.join('&');
    } else {
      location.href = location.pathname
    }
  }
}

function reloadFilters(element, param = '') {
  const params = [];
  // console.log(element)
  const inputs = document.querySelectorAll('input:checked');
  const selected = [];
  if (inputs.length > 0 && param === "") {
    inputs.forEach(i => {
      if (i.dataset.param !== element.dataset.param) {
        selected.push(i.dataset.param + '=' + i.value)
      }
    })
  }
  if (element.checked) {
    selected.push(element.dataset.param + '=' + element.value)
  }

  const search_input = document.querySelector('#search-field');
  if (search_input && search_input.value !== "") {
    selected.push("q=" + search_input.value)
  }

  if (param !== "") {
    selected.push(param + '=' + element.value)
  }

  // console.log(selected)
  if (selected.length > 0) {
    location.href = location.pathname + '?' + selected.join('&');
  } else {
    location.href = location.pathname
  }
}

window.filterSidebarLoad = (url, ctl) => {
  const category_sidebar = document.querySelector('#FilterSidebar')
  fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: { "Content-Type": "application/json" },
  })
  .then(result => {
    const p = Promise.resolve(result.json());
    p.then(v => {
      // console.log(v)
      category_sidebar.innerHTML = v.html
      const closeSidebar = function () {
        document.querySelector('.category-page__sidebar__overlay').style.visibility = ''
        document.querySelector('.category-page__sidebar__overlay').style.opacity = ''
        sidebar.style.visibility = '';
        sidebar.style.opacity = '';
        document.body.style.overflow = '';
      };
      document.querySelector('.category-page__sidebar__container__close__button').addEventListener('click', closeSidebar);
      if (ctl === 'sizes') {
        sizesToggleState(true)
      } else {
        sizesToggleState(false)
      }
      if (ctl === 'colors') {
        colorsToggleState(true)
      } else {
        colorsToggleState(false)
      }
      if (ctl === 'producers') {
        producersToggleState(true)
      } else {
        producersToggleState(false)
      }
      promosalesToggleState()
    })
  })
}
